export interface TypeId {
    id: string;
  };
